import axiosClient from './axiosClient';
import { IForgotPasswordPayload, ILoginPayload, IResetPasswordPayload } from '~/utils/interface/auth';

// change password
export interface IChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}
export interface IChangePasswordResponse {
  message: string;
  success: boolean;
}
const authApi = {
  login(data: ILoginPayload) {
    return axiosClient.post('/api/auth/login', data);
  },
  changePassword(data: IChangePasswordPayload) {
    return axiosClient.put('/api/settings/change-password', data);
  },
  forgotPassword(data: IForgotPasswordPayload) {
    return axiosClient.post('/api/auth/forgot-password', data);
  },
  resetPassword(data: IResetPasswordPayload) {
    return axiosClient.post('/api/auth/reset-password', data);
  },
};

export default authApi;
